import PublicRoutes from "./public.routes";
import PrivateRoutes from "./private.routes";

export default [...PublicRoutes, ...PrivateRoutes]